import { Link } from "react-router-dom";
//import './App.css';
//import '../../common/css/newstuff.css';

export default function Landing() {
  return (
    <div>
      <h1>Weight Loss Challenge Recording Application</h1>
      <nav
        style={{
          borderBottom: "solid 1px",
          paddingBottom: "1rem",
        }}
      >
      <Link to="/seasonlist">Season List</Link>
      </nav>
    </div>
  );
}